import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * SSO login is now consolidated into the main /login page.
 * This component redirects for backward compatibility.
 */
function LoginSSO() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/login', { replace: true });
  }, [navigate]);

  return null;
}

export default LoginSSO;
